export default "__VITE_ASSET__C9qb6V95__"